import { useSelector } from 'react-redux';
import { getPartName } from '@app/utils/commonUtils';
import { convertFormattedNumberToUnformatted } from '@app/components/pages/checkout/utils';
import { useFitmentCheck } from '@app/hooks';

const useWishlistGAEvent = ({ listProducts, priceAndAvailability }) => {
  const store = useSelector(s => s.store) ?? '';
  const { getFitmentCheck } = useFitmentCheck();
  const dealerStore = useSelector(s => s.common?.storeLocationName) || '';

  const getOtherStores = store?.otherStores?.dealerStores.map(
    store => store.name
  );

  const model = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.model
  );

  return listProducts?.map((product, index) => ({
    partNumber: product?.partNumber,
    name: getPartName(product?.partNumber, product?.name) || '',
    businessUnit: 'PCC',
    coupon: '',
    discountedAmount: convertFormattedNumberToUnformatted(
      priceAndAvailability?.[product?.partNumber]?.discountedAmount || ''
    ),
    price:
      convertFormattedNumberToUnformatted(
        priceAndAvailability?.[product?.partNumber]?.discountedPrice || ''
      ) || product?.price,
    position: index + 1,
    brand: product?.manufacturer || 'Cat',
    category: product.categoryPath?.split('/'),
    itemCatEntryId:
      priceAndAvailability?.[product?.partNumber]?.itemCatEntryId || '',
    list: '',
    locationId: getOtherStores?.join('|') || dealerStore,
    quantity:
      priceAndAvailability?.[product?.partNumber]?.quantity ||
      product?.quantity,
    availability:
      priceAndAvailability?.[product?.partNumber]?.availability || '',
    sourcingDetails:
      priceAndAvailability?.[product?.partNumber]?.sourcingDetails || '',
    productWeight: priceAndAvailability?.[product?.partNumber]?.weight || '',
    relatedModel: model || '',
    checkFitment: getFitmentCheck(product?.partNumber) || ''
  }));
};

export default useWishlistGAEvent;
